import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DisclaimerContextType {
  isVisible: boolean;
  activeDisclaimerNumber: string | null;
  showDisclaimer: (number: string) => void;
  hideDisclaimer: () => void;
  toggleDisclaimer: (number: string) => void;
}

const DisclaimerContext = createContext<DisclaimerContextType | undefined>(undefined);

interface DisclaimerProviderProps {
  children: ReactNode;
}

export const DisclaimerProvider: React.FC<DisclaimerProviderProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeDisclaimerNumber, setActiveDisclaimerNumber] = useState<string | null>(null);

  const showDisclaimer = (number: string) => {
    setActiveDisclaimerNumber(number);
    setIsVisible(true);
  };

  const hideDisclaimer = () => {
    setIsVisible(false);
  };

  const toggleDisclaimer = (number: string) => {
    if (isVisible && activeDisclaimerNumber === number) {
      hideDisclaimer();
    } else {
      showDisclaimer(number);
    }
  };

  return (
    <DisclaimerContext.Provider
      value={{
        isVisible,
        activeDisclaimerNumber,
        showDisclaimer,
        hideDisclaimer,
        toggleDisclaimer,
      }}
    >
      {children}
    </DisclaimerContext.Provider>
  );
};

export const useDisclaimerContext = (): DisclaimerContextType => {
  const context = useContext(DisclaimerContext);
  if (!context) {
    throw new Error('useDisclaimerContext must be used within a DisclaimerProvider');
  }
  return context;
};